$(document).ready(function() {
	$('.card-toggle.close').click(function() {
		var parent = $(this).parent().parent();
		var subSection = $(this).parent().parent().children('.sub-section').first();

		subSection.slideUp('slow', function(){
			$(this).css('display', '');
			parent.removeClass('expanded');
		})
	});
	$('.card-toggle.open').click(function() {
		var parent = $(this).parent().parent();
		var subSection = $(this).parent().parent().children('.sub-section').first();

		subSection.slideDown('slow', function(){
			$(this).css('display', '');
			parent.addClass('expanded');
		})
	});
});
